define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function InfectedFileFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    InfectedFileFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: InfectedFileFail,
        className: 'InfectedFileFail',
        radarName: 'fail_{SOURCE}_infected-file',
        message: [
            'Файл заражен вирусом.',
            '<a href="https://help.mail.ru/cloud_web/kas" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = InfectedFileFail;
});
